import type { ReactNode } from "react";
import { Auth0Provider } from "@auth0/auth0-react";
import { AuthProvider } from "react-oidc-context";
import { auth0Config } from "@/config/auth0";
import { Auth0Bridge } from "./Auth0Bridge";
import { CognitoBridge } from "./CognitoBridge";
import { crearUserManager } from "./cognitoUserManager";
import { cognitoConfigFromEnv, defaultIdpFromEnv, resolveSessionIdp } from "./idpSession";

const cognitoConfig = cognitoConfigFromEnv(import.meta.env as Record<string, string | undefined>);
const sessionIdp = resolveSessionIdp(
  window.location.search,
  window.localStorage,
  cognitoConfig !== null,
  defaultIdpFromEnv(import.meta.env as Record<string, string | undefined>)
);

const userManager =
  sessionIdp === "cognito" && cognitoConfig
    ? crearUserManager(cognitoConfig, window.location.origin)
    : null;

// El query param ya cumplió: que no quede en la URL ni se mezcle con el callback de OAuth.
if (new URLSearchParams(window.location.search).has("idp")) {
  const url = new URL(window.location.href);
  url.searchParams.delete("idp");
  window.history.replaceState({}, document.title, url.toString());
}

/** Monta Auth0 (como siempre) o Cognito, según el flag de esta sesión. */
export function AppAuthProvider({ children }: { children: ReactNode }) {
  if (userManager && cognitoConfig) {
    return (
      <AuthProvider
        userManager={userManager}
        onSigninCallback={() =>
          window.history.replaceState({}, document.title, window.location.pathname)
        }
      >
        <CognitoBridge config={cognitoConfig} userManager={userManager}>
          {children}
        </CognitoBridge>
      </AuthProvider>
    );
  }

  return (
    <Auth0Provider {...auth0Config}>
      <Auth0Bridge>{children}</Auth0Bridge>
    </Auth0Provider>
  );
}
